// extracted by mini-css-extract-plugin
export default {"sections":"N7DE0"};